<!--
 * @Author: your name
 * @Date: 2021-02-01 14:23:05
 * @LastEditTime: 2022-12-08 10:36:12
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/product-detail/component/RecommandProductMutipleSizeContent/index.vue
-->
<style scoped lang="sass">
.app_container_full
  display: flex
  flex-direction: column
  height: calc(var(--vh, 1vh) * 100 - 66px)

.title
  // position: fixed
  // margin-top: -85PX
  padding: 10px 40px
  text-overflow: ellipsis
  white-space: nowrap
  border-radius: 18PX 18PX 0 0
  border-bottom: 1px solid #e8e8e9
  width: 100vw
  height: 70PX
  line-height: 48PX
  font-size: 16px
  text-align: center
  overflow: hidden
  background: #fff
  z-index: 2

.pic_container
  height: 200px
  width: 250px
  margin: auto
  margin-top: 10px
  margin-bottom: 20px

.text_introduction
  padding: 0 16px
  margin-bottom: 10px
  font-size: 12px
  font-weight: 400
  line-height: 18px
  color: #334455
  opacity: 0.75

  &.info_text
    color: var(--menu-primary-text-colour)

  .contains,
  .spicy
    margin-bottom: 10px

.img
  height: 100%
  width: 100%
  object-fit: cover

.content
  flex: 1
  overflow: auto

  .product_price
    padding: 0 15PX
    margin-bottom: 16px
    font-size: 14px
    font-weight: 500
    color: #334455

  .combo_required_box
    .combo_required
      .combo_product
        display: flex
        justify-content: space-between
        align-items: center
        padding: 10px 16px
        border-top: 1px solid rgba(50, 56, 62, .1)

        .combo_product_left
          display: flex
          align-items: center

          .combo_product_img
            width: 62px
            height: 62px
            border-radius: 4px

          .combo_product_content
            margin-left: 10px

            .dish_info_name
              margin-bottom: 12px
              line-height: 16px
              font-size: 14px
              color: var(--menu-primary-text-colour)

            .dish_info_price
              line-height: 16px
              font-size: 14px
              color: var(--menu-primary-text-colour)

            .dish_info_modifications
              display: flex
              font-size: 12px
              color: rgba(51, 68, 85, .75)

              .ellipsis_text
                max-width: 140px
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap

            .dish_info_error
              font-size: 12px
              color: #1FC1B9
              font-weight: bold
              text-decoration: underline
              letter-spacing: 0.5px

        .combo_product_right
          ::v-deep
            .material-icons
              color: var(--menu-primary-background-colour) !important

  .mutiple_size_container
    padding: 0 15PX

.footer
  padding: 20PX 0
  display: flex
  justify-content: center
  width: 100vw
  border-top: 1px solid #e8e8e9
  background: #fff
  z-index: 2

  .footer_button
    width: calc(100vw - 30PX)

  .adjustMoney
    .mark
      margin-left: 3px
      letter-spacing: 1px

.recommand_product_img
  height: 100%
  margin-right: 9px
  border-radius: 5px

.dish_info
  flex: 1
  display: flex
  flex-direction: column
  justify-content: center

  .dish_info_modifications
    display: flex
    font-size: 12px
    color: rgba(51, 68, 85, .75)

    .ellipsis_text
      max-width: 140px
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap

.dish_info_name
  margin-bottom: 12px
  line-height: 16px
  font-size: 14px
  color: var(--menu-primary-text-colour)

.dish_info_price
  line-height: 16px
  font-size: 14px
  color: var(--menu-primary-text-colour)

.error_red_text
  .dish_info_error
    color: #B00620 !important
</style>

<template lang="pug">
.app_container_full
  .title.b {{ getLocalizedItemName(newProduct) }}
  .content(ref="contentDiv")
    .pic_container
      img.img(:src="getLocalizedProductImage(newProduct)")
    div
      .product_price(v-if="isComboRecommandProduct") {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ newProduct.price | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .text_introduction.info_text {{ getLocalizedItemDescription(newProduct) }}
      .text_introduction
        contain-tags.contains(:containTags="newProduct.containsTags" :seafoodOrigin="newProduct.seafoodOrigin")
        spicy.spicy(
          v-if="newProduct.id"
          :spiceLevel="newProduct.spiceLevel"
          :tags="newProduct.tags"
        )
      mutiple-size.mutiple_size_container(
        v-if="show && newProduct.sizeSettings && newProduct.sizeSettings.mutipleSize"
        ref="mutipleSize"
        :filterOtherOption = "filterOtherOption"
        :item-list="mutipleSizeSettingsList"
        @choosedItem="choosedRecommandItem"
      )

      .combo_required_box(v-if="isComboRecommandProduct")
        .combo_required(v-for="(combo, comboIndex) in requiredComboList" :key="comboIndex")
          .combo_product(v-for="(comboProduct, index) in combo.products" :key="index" :class="{'error_red_text': !isPassValidate && verificationComboRequired(comboProduct.detail, comboIndex, index)}")
            .combo_product_left
              img.combo_product_img(:src="getComboProductSrc(comboProduct.id)")
              .combo_product_content
                .dish_info_name {{ getComboProductName(comboProduct.id) }}
                .dish_info_price.o6 {{ getRequiredProductPrice(comboProduct) }}
                .dish_info_modifications(v-if="!verificationComboRequired(comboProduct.detail, comboIndex, index) && comboModifications(comboProduct, combo.id)")
                  .ellipsis_text ({{ comboModifications(comboProduct, combo.id) }}
                  span )
                .dish_info_error.p(@click.stop="editMutipleSize(comboProduct, comboIndex, null, null, index)") {{ verificationComboRequired(comboProduct.detail, comboIndex, index) }}
            .combo_product_right.p(v-if="showComboRequiredEditIcon(comboProduct)")
              icon(size="25" @click.stop="editMutipleSize(comboProduct, comboIndex, null, null, index)") create
            .combo_product_right.p(v-else)
              icon(size="25" @click.stop="editMutipleSize(comboProduct, comboIndex, null, null, index)") visibility

      CollapseBox(
        ref="collapseBox"
        :modifications="modificationsList"
        :passList="passList"
        :recommandProductList="recommandProductList"
        :showChooseRecommandProductMutipleSizeDialog="showChooseRecommandProductMutipleSizeDialog"
        @editMutipleSize="editMutipleSize"
      )
        template(slot="recommand-product" slot-scope="props")
          img.recommand_product_img(:src="getLocalizedProductImage(props.item)")
          .dish_info
            .dish_info_name {{ getLocalizedItemName(props.item) }}
            .dish_info_price.o6(v-if="!props.each.isCombo") {{ getRecommandProductPrice(props.item.id) }}
            .dish_info_price.o6(v-else) {{ getRequiredProductPrice(props.item) }}
            .dish_info_modifications(v-if="comboModifications(props.item, props.each.id)")
              .ellipsis_text ({{ comboModifications(props.item, props.each.id) }}
              span )
          .money(v-if="Number(props.item.adjustPrice) && props.item.isCombo") {{ symbolPosition === 'after' ? '' : currencySymbol + ' ' }}{{ props.item.adjustPrice | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
          icon.dish_info_choosed.p(
            v-if="props.item.checked && choosedMutipleSize(props.item.id, props.each)"
            size="25"
            @click.stop="editMutipleSize(props.item, null, props.chooseIndex, props.index)"
          ) create
          icon.dish_info_choosed.p(
            v-if="props.item.checked && !choosedMutipleSize(props.item.id, props.each)"
            size="25"
            @click.stop="editMutipleSize(props.item, null, props.chooseIndex, props.index)"
          ) visibility

  .footer(v-if="!isUpgradeProducts || modificationsLength || show && newProduct.sizeSettings && newProduct.sizeSettings.mutipleSize")
    van-button.footer_button(
      size="large"
      type="primary"
      @click="handleClick"
    ) {{ t('done', 'DONE') }}

  .footer(v-else)
    van-button.footer_button(
      v-if="!isUpgradeProducts"
      size="large"
      type="primary"
      @click="cloneDialog"
    ) {{ t('select', 'SELECT') }}

    van-button.footer_button(
      v-else
      size="large"
      type="primary"
      @click="addUpgradeProductDialog"
    )
      .adjustMoney
        span {{ t('upgrade_for', 'UPGRADE FOR') }}
        span.mark(v-if="symbolPosition !== 'after'") {{ newProduct.price < 0 ? '-' : '+' }}{{ currencySymbol }}
        span.mark(v-else) {{ newProduct.price < 0 ? '-' : '+' }}
        span.just_price {{ parseFloat(newProduct.price) < 0 ? -parseFloat(newProduct.price) : newProduct.price | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

  Product-bottom-popup-dialog(
    v-model="showChooseRecommandProductMutipleSizeDialog"
    :round="false"
    isFixed
  )
    template(v-slot:popup-dialog)
      combo-recommand-product-mutiple-size-content(
        ref="comboRecommandProductMutipleSizeContent"
        :show="showChooseRecommandProductMutipleSizeDialog"
        :product="recommandProduct"
        :isCombo="isCombo"
        :isEdit="isEdit"
        :isPosEnable="posStatus && posStatus.posName === 'simphony'"
        @chooseRecommandMutipleSize="chooseRecommandMutipleSize"
        @chooseProductIntroduction="showChooseRecommandProductMutipleSizeDialog = false"
      )
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import MutipleSize from './../MutipleSize'
import CollapseBox from './../CollapseBox'
import Spicy from './../Spicy'
import ContainTags from './../ContainTags'
import ProductBottomPopupDialog from '../BottomPopupDialog'
import resizeHandler from '@/utils/resizeHandler'
import mixin from '@/utils/mixin'
import { _isOpenStatus } from 'utils'
import { _setProduct, } from '@/modules/store'
import { mapState } from 'vuex'
import ComboRecommandProductMutipleSizeContent from '../ComboRecommandProductMutipleSizeContent'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { getLocalizedField, getLocalizedOptionName, t, tParams } from '@/utils/language'
import { calcSelectedTotal } from '../../utils/modOptionNumber'
import {
  applySectionSelectionLimits,
  isOptionHidden,
  resolveEditCollapse,
  resolveOptionSelection,
  sectionDefaultAllowance,
  sectionLimitKind,
  sectionLowerBound,
  sectionMaxOption
} from '../../utils/modSectionState'
import { comboRequiredCopy, limitWrongCopy, rangeWrongCopy } from '../../utils/sectionDesc'

@Component({
  mixins: [resizeHandler],

  filters: {
    fix (val) {
      return formatDecimalNumber(val)
    }
  },

  components: {
    MutipleSize,
    CollapseBox,
    Spicy,
    ContainTags,
    ProductBottomPopupDialog,
    ComboRecommandProductMutipleSizeContent,
  },

  props: {
    product: {
      type: Object
    },
    show: Boolean, // Whether to display the pop-up component   // 是否显示该弹窗组件
    isUpgradeProducts: {
      type: Boolean,
      default: false
    },
    isCombo: Boolean,
    isPosEnable: Boolean,
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['venueId']),
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo,
      currentLanguage: state => state.language?.currentLanguage,
    }),
    isComboRecommandProduct() {
      return this.newProduct.type === 'combo'
    },

    mutipleSizeSettingsList() {
      return this.newProduct.sizeSettings?.settings ?? []
    },

    modificationsLength () {
      return this.newProduct?.modifications?.length ?? 0
    },

    filterOtherOption() {
      return !!((this.isCombo & this.isPosEnable))
    },

    recommandProduct() {
      return (
        this.currentEditComboProduct ??
          (this.isChooseCombo
            ? this.comboProductList.find(item => item.id === this.clickItemId)
            : this.recommandProductList.find(item => item.id === this.clickItemId))
      )
    },

    modificationsList() {
      return this.newProduct.modifications?.filter(item => !this._.isBoolean(item.isCombo) || item.isCombo) ?? []
    },

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  },

  watch: {
    show: {
      immediate: true,
      async handler (val) {
        this.newProduct = JSON.parse(JSON.stringify(this.product))

        if (this.newProduct.type === 'combo') {
          this.newProduct = this._filterComboProduct(this.newProduct)
          this._formatComboProduct()
          this._getComboProductList()
          this._getRequiredComboList()
        }

        if (this.newProduct.sizeSettings?.mutipleSize) {
          this.newProduct.sizeSettings.settings = this.newProduct.sizeSettings?.settings?.map((item, index) => {
            return {
              index,
              ...item,
              price: parseFloat(item.price).toFixed(2)
            }
          })
        }

        this.newProduct.modifications = this.newProduct.modifications.map(item => {
          // 只有改单（点铅笔重新打开一道已经配过的菜）才把选过的组摆开；
          // 第一次打开时商家配的"默认折叠"说了算，预勾选不顶开它。
          // Only a cart-line refill reopens picked sections; on a first open the
          // venue's collapse setting wins.
          const collapse = resolveEditCollapse(item, { fromCart: this.isEdit === true })

          if (!(item.id < 0) || (item.id < 0 && item.isCombo)) {
            return {
              ...item,
              collapse
            }
          } else {
            return {
              ...item,
              collapse,
              options: item.options.map(each => {
                return {
                  ...each,
                  checked: false
                }
              })
            }
          }
        })

        // Initialize choosedItemInfo when the component is not displayed
        // 组件不显示时，初始化 choosedItemInfo
        if (val) {
          this._initChoosedItemInfo()
          await this.$nextTick()
          if (this.product?.modifications?.length ?? 0) {
            this.$refs.collapseBox._getProductRequiredModificationsIndex()
          }
        } else {
          this.requiredComboList = []
          this.comboProductList = []
          this.newProduct = []
          this.choosedItemInfo = {
            price: null,
            name: null,
            default: null,
            shortName: null,
            index: null,
          }
        }
      }
    }
  }
})

class RecommandProductMutipleSizeContent extends mixins(mixin) {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  newProduct = null
  choosedItemInfo = {
    price: null,
    name: null,
    default: null,
    shortName: null,
    index: null,
  }

  modificationList = []

  passList = []

  requiredComboList = []
  comboProductList = []
  recommandProductList = []
  isPassValidate = true // Verify by adding shopping cart   // 是否通过添加购物车校验
  secondIndex = null
  firstIndex = null
  isChooseCombo = false // Is the combo product being selected?   // 选择的是不是 combo 商品
  showChooseRecommandProductMutipleSizeDialog = false
  currentEditComboProduct = null
  comboRequiredIndex = null
  // 正在编辑的那个必选子品在**组内**的下标 —— 顾客选的东西写回哪一格全靠它
  // （见 `_comboRequiredOptionIndex`）
  comboRequiredProductIndex = null

  mounted () {
    this._setVh()
  }

  // Format Combo Product Price
  // 格式化 Combo 商品价格
  _formatComboProduct() {
    this.newProduct.comboProducts.forEach(combo => {
      combo.products.forEach(product => {
        // All size prices of single product are reset
        // 单品的 size 价格全部清零
        if (product.detail?.sizeSettings && product.detail?.sizeSettings?.mutipleSize) {
          product.detail.sizeSettings.settings.forEach(size => {
            size.price = 0
          })
          // Required products, default size is selected by default
          // 必选菜品，默认选中默认的 size
          if (combo.type === 'oneProduct') {
            const defaultSize = product.detail?.sizeSettings?.settings?.find(item => item.default)
            product.detail.selectSize = defaultSize
          }
        }
        // The deducted price of the modifications of the single product is all cleared to zero
        // 单品的减去的配菜价格全部清零
        const modificationList = product.detail?.modifications ?? []
        modificationList.forEach(modification => {
          if (modification.removeType) {
            modification.options.forEach(option => {
              option.adjustPrice = 0
            })
          }
        })
      })
    })
  }

  /**
   * Filter products in the combo
   * @param {Object} productData Product information
   * @returns {Object} Filtered product information
   */
  /**
   * 筛选套餐中的商品
   * @param {Object} productData 商品信息
   * @returns {Object} 过滤后的商品信息
   */
  _filterComboProduct(productData) {
    let comboProducts = productData.comboProducts
    if (comboProducts.length) {
      comboProducts = comboProducts.filter(comboProduct => {
        if (comboProduct?.products?.length) {
          // Filter the products off the shelf
          // 过滤掉下架商品
          const productList = comboProduct.products.filter(product => this._isShowProduct(product))
          if (productList.length) {
            // Reassign the filtered product list to the original data
            // 将过滤后的商品列表，重新赋值给原数据
            comboProduct.products = productList
            return true
          }
        }
        return false
      })
      // Reassign the filtered product list to the original data
      // 将过滤后的商品列表，重新赋值给原数据
      productData.comboProducts = comboProducts
      return productData
    }
  }

  /**
   * Whether to display products
   */
  /**
   * 是否显示商品
   */
  _isShowProduct(product) {
    const { status, allowDelivery, allowDinein, allowOnline, operatingHours } = product?.detail ?? product
    const isOnline = this.isOnline || this.$route.path.includes('/o/')
    // Judge whether the products are displayed in the delivery environment
    // 判断商品是否展示在外卖环境
    if (isOnline && !allowDelivery) return false
    // 按当前点单模式过滤推荐位：后端 2026-08-27 起在推荐项上带分类级模式旗
    // （allowDinein / allowOnline，缺键 = 放行，兼容旗子普及前的缓存）。
    // 没有这道门，dine-in 会展示只在 online/pickup 档分类里的推荐商品 ——
    // 顾客点进去加购的东西根本不在当前菜单里
    if (isOnline && allowOnline === false) return false
    if (!isOnline && allowDinein === false) return false
    return status && _isOpenStatus(operatingHours, 'sameAsProductGroup')
  }

  choosedMutipleSize(id, product) {
    let pass = false
    if (product.id < 0 && product.isCombo) {
      const comboProduct = this.comboProductList.find(item => item.id === id)
      const modifications = !!comboProduct?.modifications.length
      pass = comboProduct?.selectSize?.name || comboProduct?.modifications.find(item => item.type === 'required' && item.options.find(option => option.checked)) || !!modifications
    } else {
      const recommandProduct = this.recommandProductList.find(item => item.id === id)
      pass = recommandProduct?.selectSize?.name || recommandProduct?.modifications.find(item => item.type === 'required' && item.options.find(option => option.checked))
    }
    return pass
  }

  // Get Combo List
  // 获取 Combo 列表
  _getComboProductList() {
    const commandList = this.newProduct.comboProducts
    if (!this.isEdit) {
      const modifications = commandList.map((item, comboIndex) => ({
        ...item,
        // Get localized displayName with fallback / 获取本地化的 displayName（带回退）
        name: getLocalizedField(item, 'displayName') || item.name,
        id: item.type === 'required' ? -1 : '',
        options: item.products.map((products, productIndex) => ({
          ...products,
          // 这一格在整份套餐里的位置 —— 与主商品页同一套编号，见 `_comboProductForSlot`。
          // 纯客户端字段：进订单的那层 `_setProduct` 是白名单，带不出去。
          _comboSlot: `${comboIndex}:${productIndex}`,
          languages: products?.detail?.languages || products?.languages || {},
          isCombo: item.type === 'required',
          checked: item.type === 'oneProduct', // Can be set as the default check   // 可以设置为默认勾选
          disabled: false,
          unShow: false,
        })),
        isCombo: item.type === 'required',
        checked: false, // Can be set as the default check   // 可以设置为默认勾选
        disabled: false,
        unShow: false,
        adjustPrice: 0,
      }))
      this.newProduct.modifications = [...modifications, ...this.newProduct.modifications]
    }

    if (commandList.length) {
      commandList.forEach((item, index) => {
        item.products.forEach(async(each, i) => {
          this._getEveryComboProduct(each, commandList, index, i)
        })
      })
    } else {
      if (this.newProduct.comboProductList.length) this.comboProductList = this.newProduct.comboProductList
    }
  }

  // Initialize the RecommandProduct obtained by the interface
  // 对接口获取的 RecommandProduct 进行初始化操作
  _getRecommandProduct(data) {
    const ls = []
    return {
      ...data,
      price: parseFloat(data.price).toFixed(2),
      modifications: data.modifications.map(item => {
        // 可选组与必选组都认商家配的 default（owner 2026-08-12 拍板放开必选组），
        // 而且一组最多认「有效上限」个 —— 多下发的、以及顾客看不见的一律不预勾选，
        // 见 sectionDefaultAllowance。这条路不保留已有勾选（整批按新菜单数据重来），
        // 所以不传 preserveRuntimeChecked，额度也就不预扣。
        const allowDefaultAt = sectionDefaultAllowance(item)
        const options = item.options.map((each, index) => {
          const { checked, number } = resolveOptionSelection(each, { allowDefault: allowDefaultAt(index) })
          return {
            ...each,
            checked,
            disabled: false,
            number,
          }
        })
        // Grey out the options that can no longer be picked once the pre-picked
        // ones are counted, so nothing looks tappable when it is not.
        // 预勾选算进去之后，把已经选不了的选项置灰，避免"看着能点、点了没反应"
        return applySectionSelectionLimits({
          ...item,
          options,
          wrong: false,
        })
      }),
      sizeSettings: {
        mutipleSize: data.sizeSettings?.mutipleSize ?? false,
        settings: data.sizeSettings?.settings?.map((item, index) => ({
          ...item,
          price: parseFloat(item.price).toFixed(2),
          onlinePrice: parseFloat(item?.onlinePrice ?? item.price).toFixed(2),
          index
        }))
      }
    }
  }

  async _getEveryComboProduct(each, commandList, index, i) {
    const res = each.detail
    this.comboProductList.push(this._getRecommandProduct({
      ...res,
      // 这条记录属于哪一格 —— 与盖在格子上的那个键同一套编号（组下标:组内下标）。
      _comboSlot: `${index}:${i}`,
      recommendationProducts: [],
      num: 1
    }))

    this.comboProductList = this.comboProductList.map(item => {
      if (item.sizeSettings) {
        return {
          ...item,
          sizeSettings: {
            mutipleSize: item.sizeSettings?.mutipleSize ?? false,
            settings: item.sizeSettings?.settings?.map((item, index) => ({ ...item, index }))
          }
        }
      } else {
        return item
      }
    })

    if (!res.status) {
      commandList[index].options[i].unShow = true
    }
  }

  _getRequiredComboList() {
    this.requiredComboList = this.newProduct?.modifications?.filter(item => item.type === 'oneProduct') ?? []
    if (this.requiredComboList.length > 0) {
      this.requiredComboList = this.requiredComboList.map(item => ({
        ...item,
        products: (item.options ?? item.products).map(product => ({
          ...product,
          detail: {
            ...product.detail,
            modifications: product.detail.modifications.map(mod => {
              // 可选组与必选组都认 default（owner 2026-08-12 拍板放开必选组），
              // 而且一组最多认「有效上限」个，看不见的选项不认也不占额度，
              // 已经勾着的份数先占额度，见 sectionDefaultAllowance
              const allowDefaultAt = sectionDefaultAllowance(mod, { preserveRuntimeChecked: true })
              const options = mod.options.map((option, index) => {
                // Keep what the customer already chose; only fresh options use
                // the venue's pre-picked `default`.
                // 保留顾客已有的选择，只有全新的选项才用 default 预勾选
                const { checked, number } = resolveOptionSelection(option, {
                  allowDefault: allowDefaultAt(index),
                  preserveRuntimeChecked: true
                })
                return {
                  ...option,
                  disabled: false,
                  unShow: false,
                  checked,
                  number,
                }
              })
              // 预勾选算进去之后重算一次置灰，套餐子品也要有。
              // Recompute the greyed-out state for combo items as well.
              return applySectionSelectionLimits({ ...mod, options })
            })
          }
        }))
      }))
    }
  }

  /**
   * 这个必选子品**真正会随单进购物车**的那份配置 —— 与主商品页
   * `views/product-detail/index.vue` 的同名方法逐字一致。
   *
   * 闸门与写入必须读同一个对象，否则「闸门放行的」与「厨房收到的」不是一回事。
   * `requiredComboList[g].products[p]` 是 `_getRequiredComboList` **map 出来的
   * 新对象**，只用来画屏幕；进购物车的是 `_saveComboProductList` →
   * `_addEachComboProductToCart` 读的 `newProduct.modifications[g].options[p].detail`
   * —— 两份对象图互不相通。而 `requiredComboList[g].options` 与
   * `newProduct.modifications[g].options` 是**同一个数组**（`{...item}` 是浅拷贝），
   * 所以从这里能取到那份真货。
   *
   * @param index {Number} 必选组在 requiredComboList 里的下标
   * @param productIndex {Number} 子品在组内的下标
   * @return {Object|undefined} 随单进购物车的那份 detail；取不到时由调用方回落
   */
  _comboRequiredCartDetail(index, productIndex) {
    if (typeof index !== 'number' || typeof productIndex !== 'number') return undefined
    const group = (this.requiredComboList ?? [])[index]
    const options = group?.options ?? group?.products ?? []
    return options[productIndex]?.detail
  }

  /**
   * Verify whether the required modifications of combo single product is passed
   * @param detail {Object} Details of single product
   * @param index {Number} Subscript of the required group
   * @param productIndex {Number} Subscript of the sub product inside that group
   * @return {String} Text of error prompt
   */
  /**
   * 验证 combo 单品必填配菜是否通过
   * @param detail {Object} 单品的详细信息（取不到"随单那份"时的回落）
   * @param index {Number} 必选组（oneProduct 组）的下标
   * @param productIndex {Number} 该子品在组内的下标
   * @return {String} 错误提示的文案
   */
  verificationComboRequired(detail, index = null, productIndex = null) {
    // 判据是**这一格自己的内容**，不是「顾客点开过这个弹层并按了确认」。
    //
    // 以前这里是一张按下标发的通行证（`comboRequiredPassList`）：发过票就放行。
    // 票记的是「按过确认」，不是「这个子品自己那格选够了」，于是
    //   (a) 写入落到别的格子上时，票照发、闸门照放，厨房收到的那件仍然缺配菜；
    //   (b) 顾客被迫把同一件配第二遍，另一件永远没人管。
    // 票是代理指标，内容才是事实 —— 所以这里只问内容。
    const source = this._comboRequiredCartDetail(index, productIndex) ?? detail
    const modifications = source?.modifications ?? []
    let num = 0
    // 还差几样没选 / how many picks are still missing
    modifications.forEach(item => {
      if (item.type !== 'required') return
      const options = item.options ?? []
      // 一样都点不到的组（空组，或选项全是 `unShow`）：弹层自己那道
      // `_validateRequiredModifications` 也放行（`!options.every(o => o.unShow)`），
      // 这里跟着放行 —— 否则这个套餐会变成**永远加不进购物车**。
      // 这种商品本来就不该摆出来，那道门在 utils/productDisplay。
      //
      // ⚠️ 已知的一处不对称，两半读的不是同一份 `unShow`：屏幕读的是
      // `_getRequiredComboList` map 出来的副本（那里把子品配菜选项**写死**
      // `unShow: false`），这道门读的是随单那份原始 `options[p].detail`。
      // 真出现「后端把必选组里所有选项都下发成 unShow」的数据，屏幕会画成可点、
      // 这道门却跳过。现在仓里没有给子品自身配菜选项写 `unShow` 的代码，举不出
      // 真实形状，所以只在这里记一笔；哪天要改，两半必须一起改。
      if (options.every(isOptionHidden)) return
      // 「至少要选几样」的唯一定义在 utils/sectionLimit 的 `sectionLowerBound`
      // （必选组恒 >= 1；四种 limitType 出自同一次 `sectionBounds` 计算）。
      // 「已经选了几样」的唯一定义在 utils/modOptionNumber 的 `calcSelectedTotal`
      // （`number > 0` 时按份数算，与置灰、数量步进同口径）。
      // 两个数都必须问这两个函数 —— 在这里自己解析 `minOption` / 自己数 `checked`
      // 就是让闸门与弹层哪天各说各话。
      const missing = sectionLowerBound(item) - calcSelectedTotal(options)
      if (missing > 0) num += missing
    })
    if (!modifications.length || !num) return ''
    // 这句话的唯一实现在 utils/sectionDesc 的 `comboRequiredCopy`（两个渲染文件共用）。
    // 以前这里是写死的英文模板串 `${num} selections required!`：不过语言包（法语 /
    // 中文门店的顾客看到一句英文）、而且是报错口气而不是「动词 + 结果」。
    // 数怎么来的仍然归上面那个循环管，本行只负责把它说成人话。
    return comboRequiredCopy(num)
  }

  /**
   * Get pictures of combo products
   * @param {String} Commodity ID
   * @returns {String} Package product picture
   */
  /**
   * 获取套餐商品图片
   * @param {String} 商品 id
   * @returns {String} 套餐商品图片
   */
  getComboProductSrc(id) {
    const product = this.comboProductList.find(item => item.id === id)
    return product ? this.getLocalizedProductImage(product) : ''
  }

  /**
   * Get localized product image
   * 获取本地化的产品图片
   */
  getLocalizedProductImage(product) {
    if (!product) return ''
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(product, 'image') || product.image || ''
  }

  /**
   * Get localized item name / 获取本地化的项目名称
   */
  getLocalizedItemName(item) {
    if (!item) return ''
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(item, 'name') || item.name
  }

  getLocalizedItemDescription(item) {
    if (!item) return ''
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(item, 'description') || item.description || ''
  }

  /**
   * Get combo product name
   * @param {String} Commodity ID
   * @returns {String} Package product name
   */
  /**
   * 获取套餐商品名称
   * @param {String} 商品 id
   * @returns {String} 套餐商品名称
   */
  getComboProductName(id) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    const product = this.comboProductList.find(item => item.id === id)
    return product ? (getLocalizedField(product, 'name') || product.name) : ''
  }

  /**
   * Get product price copy
   * @param data {Object} Product information
   * @return {String} Size of side dishes
   * For example: size name - size amount
   */
  /**
   * 获得商品价格文案
   * @param data {Object} 商品信息
   * @return {String} 配菜的 size
   * 例如：size 名字 - size 金额
   */
  getRequiredProductPrice(data) {
    const name = data?.detail?.selectSize?.name
    const price = data?.detail?.selectSize?.price
    const symbol = getCurrencySymbol()
    const position = getSymbolPosition()
    if (name === null || price === null || data?.detail?.selectSize === undefined) return
    if (position === 'after') {
      return name + ' - ' + price + ' ' + symbol
    }
    return name + ' - ' + symbol + price
  }

  /**
   * Combo products, showing the list of modifications of the required items
   * @param productInfo {Object} Commodity Details
   * @param id {Number, String} The ID of the product group. When id===- 1, it indicates that it is a recommended dish or an optional dish of combo
   * @return {String} Copy of side dishes list of required items
   */
  /**
   * combo 商品，展示必选单品的配菜列表
   * @param productInfo {Object} 商品详情
   * @param id {Number, String} 商品分组的 id。 id === -1 时，说明是推荐菜或者是 combo 的可选菜品
   * @return String 必选单品的配菜列表的文案
   */
  comboModifications(productInfo, id) {
    let text = ''
    if (productInfo.checked) {
      const modifications = productInfo.detail?.modifications ?? []
      modifications.forEach(item => {
        item.options.forEach(option => {
          if (option.checked) {
            // 同一句摘要在主商品页（views/product-detail/index.vue 的
            // `comboModifications`）念的是本地化名字，这里以前念的是后台原名 ——
            // 同一个套餐，主页面念「番茄酱」、多规格弹层念「Ketchup」。
            // 逐字对齐主商品页那一份（`getLocalizedOptionName` 说不出话时才回原名）。
            const optName = getLocalizedOptionName(option) || option.name
            if (text) text += `, ${optName}`
            else text += optName
          }
        })
      })
    }
    return text
  }

  /**
   * Edit Product
   * @param product {Object} Product information
   * @param comboRequiredIndex {Number} The subscript of the mandatory item of the combo product. This value is only available if the mandatory item of the combo product is clicked
   * @param chooseIndex {Number} The recently selected corresponding side dish option subscript
   */
  /**
   * 编辑商品
   * @param product {Object} 商品信息
   * @param comboRequiredIndex {Number} combo 商品的必选单品的下标，只有点击的是 combo 商品的必选单品，才会有此值
   * @param chooseIndex {Number} 最近选中的对应的配菜选项下标
   * @param firstIndex {Number}
   * @param comboRequiredProductIndex {Number} 必选子品在组内的下标（通行证的另一半）
   */
  editMutipleSize(product, comboRequiredIndex = null, chooseIndex = null, firstIndex = null, comboRequiredProductIndex = null) {
    if (product.disabled) return
    this.clickItemId = product.id
    this.comboRequiredIndex = comboRequiredIndex
    this.comboRequiredProductIndex = comboRequiredProductIndex
    // The recently selected corresponding modification option subscript
    // 最近选中的对应的配菜选项下标
    if (typeof chooseIndex === 'number') this.secondIndex = chooseIndex
    if (typeof firstIndex === 'number') this.firstIndex = firstIndex
    // Is the combo product clicked?
    // 点击的是不是 combo 商品
    this.isChooseCombo = typeof comboRequiredIndex === 'number' || product.isCombo
    this.showChooseRecommandProductMutipleSizeDialog = true
    const currentRecommandProduct = this.recommandProductList.find(item => item.id === product.id)
    this.currentEditComboProduct = currentRecommandProduct ?? product.detail ?? product
  }

  /**
   * Display the edit icon of combo required items
   * @param comboProduct {Object} Information of combo required items
   * @return {Boolean} Whether to display
   */
  /**
   * 显示 combo 必选单品的 edit 图标
   * @param comboProduct {Object} combo 必选单品的信息
   * @return {Boolean} 是否显示
   */
  showComboRequiredEditIcon(comboProduct) {
    const detail = comboProduct.detail ?? {}
    return detail?.sizeSettings?.mutipleSize || detail?.modifications?.length
  }

  /**
   * collapseBox 那份列表（`modificationsList`，已过滤掉 oneProduct 组）的下标
   * → `this.newProduct.modifications` 的下标。
   *
   * 必选单品（isRequiredCombo）那条路拿到的 firstIndex 本来就是
   * `this.newProduct.modifications` 的下标（`comboRequiredIndex` / `findIndex`），
   * 不需要换算。
   *
   * @param index {Number} collapseBox 那份列表里的下标
   * @param isRequiredCombo {Object|undefined} 命中的 oneProduct 组，没命中是 undefined
   * @return {Number} this.newProduct.modifications 里的下标
   */
  _toModificationsIndex(index, isRequiredCombo) {
    if (!this.requiredComboList.length || isRequiredCombo) return index
    return index + this.requiredComboList.length
  }

  /**
   * 被点的那个必选子品在组里的下标 —— 顾客选的东西要写回**这一格**。
   * 与主商品页 `views/product-detail/index.vue` 的同名方法逐字一致。
   *
   * 只能按下标认，不能按 id 认：一个 `oneProduct` 组里「同一个子品要 2 份」是靠
   * **重复条目**承载的（见 STSGen2 的 comboGroup.count 语义），按 id 找会把第 2、
   * 第 3 条全算到第 1 条头上。
   *
   * 模板漏传下标时（`comboRequiredProductIndex` 是 null）回落到按 id 找 —— 比写死
   * 0 强，重复条目那种少数情况才会落错；正确接线由
   * `tests/unit/views/productDetailComboSubItemIndex.spec.js` 的接线钉守着。
   *
   * @param group {Object} 命中的 oneProduct 组
   * @param product {Object} 弹层交回来的子品
   * @return {Number} 该子品在组内 `options` / `products` 里的下标
   */
  _comboRequiredOptionIndex(group, product) {
    const options = group?.options ?? group?.products ?? []
    const productIndex = this.comboRequiredProductIndex
    if (
      typeof this.comboRequiredIndex === 'number' &&
      typeof productIndex === 'number' &&
      productIndex > -1 && productIndex < options.length
    ) return productIndex
    const byId = options.findIndex(option => option.id === product?.id)
    return byId > -1 ? byId : 0
  }

  /**
   * 这一格（`modifications[组].options[子品]`）对应的那条 `comboProductList` 记录。
   * 与主商品页 `views/product-detail/index.vue` 的同名方法逐字一致。
   *
   * `comboProductList` 是 `_getEveryComboProduct` **一格一条 push** 出来的位置列表：
   * 同一个子品在一个 `oneProduct` 组里放两条（份数靠重复条目承载），列表里就有两条
   * 同 id 的记录。按 id 取时 `find` 永远返回第一条 —— 两格的配置全算到第一条头上，
   * 而 `_addEachComboProductToCart` 的 override 支读的正是这个列表，
   * 所以**厨房收到的两行一模一样**。
   *
   * 取不到键才回落到按 id 找。⚠️ **回落本身就是这条缺陷**，它只是最后一道保险，
   * 不是常规路径 —— 上线之前建的购物车行两头都没有这个键，那些行靠
   * `store/cartSchemaVersion.js` 在恢复 localStorage 那一刻整个作废掉。
   *
   * @param slot {Object} `modifications[组].options[子品]` 这一格
   * @param fallbackId {String|null} 格子上没 id 时的兜底（调用方一般给 `clickItemId`）
   * @return {Object|undefined} 这一格的那条记录
   */
  _comboProductForSlot(slot, fallbackId = null) {
    const list = this.comboProductList ?? []
    const key = slot?._comboSlot
    const bySlot = typeof key === 'string' ? list.find(item => item._comboSlot === key) : undefined
    if (bySlot) return bySlot
    return list.find(item => item.id === (slot?.id ?? fallbackId))
  }

  chooseRecommandMutipleSize({ selectSize, product, combo }) {
    let firstIndex = this.firstIndex
    let secondIndex = this.secondIndex

    // Is it a required product of the combo
    // 是不是套餐的必选商品
    //
    // ⚠️ `comboRequiredIndex` 已经指明是**哪一组**了，就别再按 id 找回去：两个
    // `oneProduct` 组共用同一个子品时，按 id 找永远返回第一组，而组内下标用的是顾客
    // 真正点的那一组的 —— 选择被写进**另一个商品**，顾客点的那一格一个字都没写。
    // 闸门只认内容，那一格于是永远红：套餐永远加不进购物车。
    const isRequiredCombo = (typeof this.comboRequiredIndex === 'number'
      ? this.requiredComboList[this.comboRequiredIndex]
      : undefined) ??
      this.requiredComboList.find(item => item.options.findIndex(option => option.id === product.id) > -1)

    if (this.isChooseCombo) {
      if (typeof this.comboRequiredIndex === 'number' && isRequiredCombo) {
        // 组在 `newProduct.modifications` 里的下标：按**同一个 options 数组**认。
        // `_getRequiredComboList` 造的是新对象，但 `options` 是浅拷贝出来的同一个数组
        // 引用，所以这是唯一不会认错的判据 —— 按 (id, name) 找会在两个同名 oneProduct
        // 组之间选错（所有 oneProduct 组的 id 都是 `''`）。
        const byOptions = this.newProduct.modifications.findIndex(item => item.options === isRequiredCombo.options)
        if (byOptions > -1) {
          firstIndex = byOptions
        } else if (isRequiredCombo.id === '' || isRequiredCombo.id === '-1') {
          firstIndex = this.newProduct.modifications.findIndex(
            item => item.id === isRequiredCombo.id && item.name === isRequiredCombo.name
          )
        } else {
          firstIndex = this.comboRequiredIndex
        }
        // 写回**被点的那一格**，不是这一组的第 0 格（见 `_comboRequiredOptionIndex`）。
        secondIndex = this._comboRequiredOptionIndex(isRequiredCombo, product)
      }

      if (typeof firstIndex === 'undefined') firstIndex = 0

      // ⚠️ 下标换算必须在这一句**之前**做，不能等到下面写 checked / adjustPrice 那一步。
      // `this.firstIndex` 来自 collapseBox 的 `props.index`，而 collapseBox 收的是
      // `modificationsList` —— 那份列表把 oneProduct 组过滤掉了（它们另在
      // `.combo_required` 里单独渲染）。`this.newProduct.modifications` 里那些组还在，
      // 而且（管理端 `comboDraft.ts` 的 `orderComboGroups()` 强制）排在最前面，
      // 所以两份列表的下标恒差一个 `requiredComboList.length`。
      //
      // 少补这一段，下面这个 `option` 指的就是**另一个子品**：顾客选的规格与配菜
      // 被写进它的 `detail`（`detail.modifications` / `detail.selectSize`），随单进 POS；
      // 而 `checked` 与 `adjustPrice` 打在对的组上（那两句用的是换算后的下标），
      // 于是屏幕上完全正常 —— 只有厨房和小票是错的。
      firstIndex = this._toModificationsIndex(firstIndex, isRequiredCombo)

      const option = this.newProduct.modifications[firstIndex].options[secondIndex]
      // Find the corresponding combo product and assign a value
      // 找到对应的 combo 商品并赋值 —— 按**这一格**取，不是按 id 取（见 `_comboProductForSlot`）
      const comboProduct = this._comboProductForSlot(option, this.clickItemId)
      // 顾客选的东西**先无条件写进这一格自己**（与主商品页同一处理，理由见那一份）：
      // 记录一条都找不到时，以前顾客点了等于没点 —— 闸门读的就是 `options[].detail`，
      // 那一格于是永远红、点多少次都清不掉。
      //
      // ⚠️ 三个取值**刻意都不加可选链**：任何一个取不到都是接线错了，当场抛比静默跳过
      // 强得多（静默跳过 = 记录写了、格子没写，闸门恒红）。先读 `product.modifications`
      // 是为了不在 `product` 缺席时先把这一格清成 `[]` 再抛。
      option.detail.modifications = product.modifications ?? []
      option.detail.selectSize = selectSize
      if (typeof comboProduct !== 'undefined') {
        comboProduct.modifications = product.modifications
        comboProduct.selectSize = selectSize
      }
    } else {
      this.recommandProductList.find(item => item.id === this.clickItemId).selectSize = selectSize
      this.recommandProductList.find(item => item.id === this.clickItemId).modifications = product.modifications
    }

    if (isRequiredCombo) {
      // 屏幕上那份列表也要写到**同一格**：`products` 与 `options` 是 1:1 map 出来的，
      // 所以下标通用。按 id 找会把同组的重复条目（份数靠重复条目承载）全算到第一条头上，
      // 于是屏上显示的配菜与随单发出的是两条。
      const optionIndex = this._comboRequiredOptionIndex(isRequiredCombo, product)
      const requireComboProduct = (isRequiredCombo.products ?? [])[optionIndex] ??
        (isRequiredCombo.products ?? []).find(item => item.id === product.id)
      if (requireComboProduct?.detail) {
        requireComboProduct.detail.modifications = product?.modifications ?? []
        requireComboProduct.detail.selectSize = selectSize
      }
    }

    // isChooseCombo 那一支已经在上面换算过（两处 `modifications[firstIndex]` 必须同一个
    // 下标空间），这里只补另一支 —— 推荐菜那条路不进上面的分支。
    if (!this.isChooseCombo) firstIndex = this._toModificationsIndex(firstIndex, isRequiredCombo)

    if (combo !== true) {
      const option = this.newProduct.modifications[firstIndex].options[secondIndex]
      option.checked = true
      if ((selectSize.price || selectSize.price === 0) && !option.isCombo) option.adjustPrice = selectSize.price
    }
    this.showChooseRecommandProductMutipleSizeDialog = false
    this.$nextTick(_ => {
      if (combo !== true) this.$refs.collapseBox.getCheckNum(firstIndex -= this.requiredComboList.length, secondIndex)
    })
  }

  handleClick() {
    this._validateRequiredModifications()
    let isPassValidate = true
    let isPassRequiredCombo = true
    if (this.isComboRecommandProduct) {
      // Whether it has passed the required modification verification of the required items
      // 是否通过必选单品的必选配菜验证
      // 闸门也逐子品问（第三个参数），否则同组第二个子品的漏配会被第一个的通行证盖住
      isPassRequiredCombo = !this.requiredComboList.find((combo, comboIndex) => combo.products.find((product, productIndex) => this.verificationComboRequired(product.detail, comboIndex, productIndex)))
    }
    isPassValidate = this.newProduct?.modifications.filter(item => item.wrong && !item.options.every(option => option.unShow)).length === 0
    this.isPassValidate = isPassRequiredCombo && isPassValidate

    if (!isPassRequiredCombo) {
      this.$nextTick(_ => {
        const targetDom = document.querySelectorAll('.combo_required')
        let errIndex = -1
        targetDom.forEach((child, childIndex) => {
          if (child.querySelector('.error_red_text') && errIndex < 0) {
            errIndex = childIndex
          }
        })
        if (errIndex > -1) targetDom[errIndex].scrollIntoView({ behavior: 'smooth' })
      })
    }
    if (isPassRequiredCombo && !isPassValidate) this.$refs.collapseBox._scrollToErrorItem()
    if (this.isPassValidate) {
      this.passList = []

      if (this.isComboRecommandProduct) {
        this._saveComboProductList(this.newProduct)
        this.newProduct.comboProductList = this.comboProductList
      }

      const product = JSON.parse(JSON.stringify(this.newProduct))
      this.$emit('chooseRecommandMutipleSize', { selectSize: this.choosedItemInfo, product })
    }
  }

  // Reconstruct the Combo format
  // 把 Combo 重构格式
  _saveComboProductList(product) {
    const modifications = []
    if (!product.modifications?.length) return
    product.modifications.forEach(every => {
      const comboProduct = {
        name: every.name,
        type: every.type,
        itemList: []
      }
      every.options.forEach(each => {
        if (each.checked && (every.id === -1 ? every.isCombo : true)) {
          const item = _setProduct(this._addEachComboProductToCart(each))
          if (each.detail) {
            each.detail.selectSize = item?.selectSize ?? null
            item.containsTags = each.detail.containsTags ?? null
            // Carry seafood country-of-origin alongside containsTags so the
            // saved item keeps the same Seafood • {origin} label everywhere.
            // 把海鲜产地与 containsTags 一起带上，保存项各处保持 Seafood • {产地}。
            item.seafoodOrigin = each.detail.seafoodOrigin ?? null
            item.adjustPrice = each.adjustPrice
          }
          comboProduct.itemList.push(item)
        }
      })
      if (comboProduct.itemList.length) modifications.push(comboProduct)
    })
    product.comboProducts = modifications
  }

  _addEachComboProductToCart(each) {
    // ⚠️ 按**这一格**取，不是按 id 取。下面那个 override 支几乎总是成立
    // （`_getRecommandProduct` 把 `checked` 归一成了布尔），所以真正进厨房的是
    // `comboProductSelectItem`；它按 id 取的时候，一个 oneProduct 组里的两条重复子品
    // 拿到的是同一条记录 —— 两行小票一模一样。
    const comboProductSelectItem = this._comboProductForSlot(each)
    let currentRecommandProduct = each.detail ?? comboProductSelectItem
    if (
      comboProductSelectItem?.modifications &&
        comboProductSelectItem?.modifications[0]?.options[0]?.checked !== undefined
    ) {
      currentRecommandProduct = comboProductSelectItem
    }
    return {
      ...currentRecommandProduct,
      name: currentRecommandProduct?.name ?? each.name,
      isJardiniere: each.isJardiniere ?? '',
      isPlus: each.isPlus ?? 'noSideDish',
      adjustPrice: '',
      price: parseFloat(currentRecommandProduct?.price ?? 0),
      venueId: this.venueId,
      productGroupId: this.$route.query.productGroupId,
      isAddItem: this._isPostPaidAddItem(),
      singlePrice: parseFloat(currentRecommandProduct?.price ?? 0),
      num: this.newProduct.num,
      recommendFromProductId: this.newProduct.id,
      recommendationProducts: [],
      productGroupCourse: this.$route.query.productGroupCourse,
      // Real price, including modifications and multipleSize
      // 真实的price，包含 modifications 与 mutipleSize
      realProductPrice: this._getRealProductPrice(currentRecommandProduct),
    }
  }

  _getRealProductPrice(product) {
    let basePrice = 0
    if (product?.selectSize?.name) {
      basePrice = parseFloat(product?.selectSize?.price ?? 0)
    } else {
      basePrice = parseFloat(product?.price ?? 0)
    }
    if (product?.modifications) {
      product.modifications.forEach(item => {
        item.options.forEach(each => {
          if (each.checked) basePrice += parseFloat(each?.adjustPrice ?? 0)
        })
      })
    }
    return basePrice
  }

  _isPostPaidAddItem() {
    // Obtain unPaidOrderNo and only pass a value for isAddItem
    // 获取 unPaidOrderNo 只为 isAddItem 传值
    const unPaidOrderNo = this.$store.state.venueUnpaidOrderList.find(item => item.venueId === this.venueId)?.unPaidOrderId ?? ''
    return this.routerInfo.paymentType === 'post-paid' && unPaidOrderNo
  }

  // Close component
  // 关闭组件
  cloneDialog() {
    this.$emit('chooseProductIntroduction')
  }

  choosedRecommandItem(item) {
    this.choosedItemInfo = item
  }

  // Options before pre filling in the edit product scenario
  // edit 商品场景下，预填写之前的选项
  _setDefault() {
    this.$refs.collapseBox._defaultChoose()
    this._getChoosedRecommandProductMutipleSizeInfo()

    // scroll to top
    if (this.$refs.contentDiv) {
      this.$refs.contentDiv.scrollIntoView()
      this.$refs.contentDiv.scrollTop = 0
    }
  }

  _initChoosedItemInfo() {
    if (!this.newProduct?.sizeSettings?.mutipleSize) return
    const defaultItem = this.newProduct?.sizeSettings?.settings?.find(item => item.default)
    if (defaultItem) this.choosedItemInfo = this.newProduct.sizeSettings.settings[defaultItem.index]
  }

  _validateRequiredModifications() {
    // Form validation. If there is an option that fails, the corresponding prompt text will be displayed and the first error will be jumped to
    // 表单验证，若有没通过的选项，显示对应提示文字，并跳转到第一个错误
    this.newProduct = {
      ...this.newProduct,
      modifications: this.newProduct.modifications.map((item) => {
        // 判据同 index.vue 的 _validateRequiredModifications：这一格自己的内容，
        // 不是「在不在 passList 里」——required 组被 default 预选满足、或改单回填
        // 已经选够时，从来没走过 getCheckNum 也该放行。passList 机制本身不动，
        // 只是这道加购闸门不再问它，也就不再需要换算 passIndex。
        if (item.type === 'required' && !item.options.every(isOptionHidden) && sectionLowerBound(item) - calcSelectedTotal(item.options) > 0) {
          // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
          // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
          // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
          // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
          const limitKind = sectionLimitKind(item)
          let wrongMsg
          if (!item.options.every(option => option.unShow)) {
            if (limitKind === 'exactly') {
              // 念的是这一组真正被校验的那个数（有效上限，见 utils/sectionLimit.js），
              // 不是裸 minOption —— 两个键都没写出数时裸值会念成 `Select  (Required)`。
              // 这一支在 `item.type === 'required'` 里，所以有效上限一定是个正整数
              // （可选的 exactly 组是 NO_CAP，但它不做校验，也就没有这句提示）。
              wrongMsg = tParams('select_n_required', 'Select {n} (Required)', { n: sectionMaxOption(item) })
            } else if (limitKind === 'range') {
              // 两个数各自要「念得出」才念，唯一实现见 utils/sectionDesc 的 rangeCopy
              wrongMsg = rangeWrongCopy(item)
            } else if (limitKind === 'limit') {
              // 这一组的校验拦的是「一样都没选」，所以念「至少选 1 样」——
              // 以前念 `Select up to {minOption}`，而那个字段在 limit 组通常是 0 或空
              wrongMsg = limitWrongCopy()
            }
          }
          return {
            ...item,
            wrong: wrongMsg
          }
        } else {
          return {
            ...item,
          }
        }
      })
    }
  }

  // When editing product, select the result of the last size
  // edit product 时，选中上次 size 的结果
  _getChoosedRecommandProductMutipleSizeInfo() {
    const activeChoosedItemInfo = this.newProduct?.selectSize?.name
    if (activeChoosedItemInfo) {
      const choosedItemIndex = this.newProduct.sizeSettings.settings.findIndex(item => item.name === this.newProduct?.selectSize?.name)
      this.$refs.mutipleSize._setChoosedIndex(choosedItemIndex)
    }
  }

  // Click OK to add and transfer the unique subscript to the parent component
  // 点击确定添加，向父组件传唯一下标
  addUpgradeProductDialog() {
    this.$emit('chooseUpgradeProduct', this.newProduct.index, this.isUpgradeProducts)
    this.cloneDialog()
  }

  _setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
  }
}

export default RecommandProductMutipleSizeContent
</script>
